import {ready} from '~/core'
import {addEvents} from '~/utils'

ready('navSkip', '.navSkip-skip', skip => {
	addEvents(skip, 'click.stop.prevent enter.stop.prevent', () => {
		const dest = document.querySelector(skip.getAttribute('href'))
		const top = dest.getBoundingClientRect().top
		const elem = dest.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0]
		window.scrollBy({
			top,
			behavior: 'smooth'
		})
		elem.focus()
	})
})